import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { ACRISS_GROUP_BY_OPTIONS } from "@constants"
import { acrissGroupBy } from "@signals"


export default function AcrissGroupBySelect({ ...props }) {
	return <SelectSeeker
		label="Group by"
		isClearable={false}
		value={acrissGroupBy.value}
		onChange={e => acrissGroupBy.value = e.target.value}
		options={ACRISS_GROUP_BY_OPTIONS}
		{...props}
	/>
}
